export const QUESTIONS = {
    'group-1' : 'What would you tell someone who asked you about VirtualGlass™?',
    'group-2' : 'What could we change/do to make VirtualGlass™ more user-friendly for participants?',
    'group-3' : 'What have we not thought of in the design of VirtualGlass™?',
    'group-4' : 'If you were a facilitator using VirtualGlass™, what features would you like included that were not showcased today?',
}